import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { featuresBox, featureslist, listAnimation, fadeIn } from '../../store/animations';
import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewSwitch, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow }  from '../animations.overlay';
import { Http, Response, Headers } from '@angular/http';

import { UserService } from '../../services/user.service';
import { SocialService } from '../../services/social.service';
import { environment } from '../../environment';



@Component({
  selector: 'network',
  templateUrl: './network.component.html',
  providers: [ UserService, SocialService ],
  animations: [ featuresBox, overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewSwitch, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow, featureslist ]
})
export class NetworkComponent implements OnInit {

	key: any;
	title: any;
	header: any;
	subtitle: any;
	headerHeight: any;
	headerAlign: any;

	showChannels: boolean;
	subtitlebar: string;
	titlebar: string;

	constructor(
		private user: UserService,
		private social: SocialService 
	) {}


	/* On with the show */
	ngOnInit() {
		this.titlebar = "Social Network";
		this.subtitlebar = "Identity Social Network";
		this.headerHeight = '300px';
		this.header = 'Network';
	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/network/network.component.ts